import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledLine = styled.div `
    width: 100%;
    height: ${props => (props.height ? props.height + '%' : '0')};
    background-image: linear-gradient(
        ${props => props.theme.secondary} 60%,
        white 0%
    );
    background-position: top right;
    background-size: 1px 14px;
    background-repeat: repeat-y;
    transition: all 150ms ease-in-out;
`;
const ProgressLine = ({ height }) => (_jsx(StyledLine, { height: height }));
export default ProgressLine;
